export const GET_PRIVACY = "@@PRIVACY/GET";
export const PUT_PRIVACY = "@@PRIVACY/PUT";

export const actionCreators = {
    getPrivacy: () => ({
        type: GET_PRIVACY, 
    }),
    putPrivacy: (payload) => ({
        type: PUT_PRIVACY,
        payload
    }),
}